import { h } from 'preact';

export const Filters = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" {...props}>
			<path d="M4.5 8c1.21 0 2.219.859 2.45 2h8.55a.5.5 0 0 1 0 1H6.95a2.501 2.501 0 0 1-4.9 0H.5a.5.5 0 0 1 0-1h1.55C2.28 8.859 3.29 8 4.5 8Zm0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm7-6c1.21 0 2.219.859 2.45 2h1.55a.5.5 0 0 1 0 1h-1.55a2.501 2.501 0 0 1-4.9 0H.5a.5.5 0 0 1 0-1h8.55c.231-1.141 1.24-2 2.45-2Zm0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"/>
		</svg>
	);
};